import {Deserializable} from './deserializable.model';
import {InvoicePayment} from './invoicePayment.model';

export class Payment {


payment_id?: number;
payment_date: string;
myob_account_code_id?: number;
myob_bank_account_code_id?: number;
from_brand_id?: number; // who the payments will be appled to. (who the payment is from)
to_brand_id?: number; // who the payments will be appled to. (who the payment is from)
payment_total?: number;
created_by?: number;
created_date?: any;
updated_by?: number;
updated_date?: any;

invoicePayment?: InvoicePayment; // class
from_brand_name?: string;
to_brand_name?: string;

job_number?: string;
subject_number?: string;
is_bulk?: number;

// myob variables.
UID?;
DepositTo?;
AccountUID?;
CustomerUID?;
URI?;
myob_array?: any;
RowVersion?;
myob_id?;

invoice_id?: number;
invoiceUID?: any;

created_date_from?;
created_date_to?;
invoice_status_id?;
invoice_payment_status_id?
invoice_communication_status_id?

  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): Payment {
    Object.assign(this, input);
    this.invoicePayment = new InvoicePayment().deserialize(input.invoicePayment);
    return this;
  }

  /*

payment_id
payment_date
myob_account_code_id
myob_bank_account_code_id
from_brand_id
to_brand_id
payment_total
created_by
created_date
updated_by
updated_date

  */


}
